import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthservicesService } from 'src/app/services/authservices.service';
import * as moment from 'moment';

@Component({
  selector: 'app-social-comment',
  templateUrl: './social-comment.component.html',
  styleUrls: ['./social-comment.component.css']
})
export class SocialCommentComponent implements OnInit {
  commentId
  currentUser
  comment
  loading = false
  arr = []
  commentArr = []
  arr1 = [1, 2, 3]
  loadMoreArr =[];
  totalItems
  pageSize
  showButton = false
  constructor(private route: ActivatedRoute, private authService: AuthservicesService) {
    this.pageSize = 3

    this.currentUser = JSON.parse(localStorage.getItem('ministry_currentUser'))
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.commentId = params["id"];
    });
    this.getCommentByPost(0);
  }

  getCommentByPost(event) {
    let skip = event
    this.authService.getcommentById(skip, this.pageSize, this.commentId).subscribe((res: any) => {
      this.loading = true
      this.commentArr = res.items
      this.totalItems = res.total
      this.concatArray(this.commentArr, this.totalItems);

      this.loadMoreArr.forEach((e) => {
        this.arr.push({
          id: (e._id) ? e._id : '',
          name: (e.postedBy.user.name) ? e.postedBy.user.name : '',
          photo: (e.postedBy.user.photo) ? e.postedBy.user.photo : '',
          description: (e.text) ? e.text : '',
          createdAt: (e.createdAt) ? moment([e.createdAt]).fromNow() : ''

        })
      })


    },
      error => {
        this.loading = true
        // this.authService.successMessage(error.error.message, 'error')
      })
  }


  createComment() {
    if (this.comment == "") {
      return
    }
    this.authService.createComment({ text: this.comment }, this.commentId).subscribe((res: any) => {
      // this.getCommentByPost()

    }, error => {
      this.authService.successMessage(error.error.message, 'error')

    })
  }
  getErrorImage(event) {
    this.authService.geterrorImage(event);
  }





  showMore() {
    const skip = this.loadMoreArr.length
    this.getCommentByPost(skip)
  }


  concatArray(arr, total) {
    if (arr.length != 0) { this.loadMoreArr = this.loadMoreArr.concat(arr) }
    else if (arr.length == 0) {
      this.showButton = false
    }
    if (this.loadMoreArr.length == total && this.loadMoreArr.length != 0) this.showButton = false
  }

}
